import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  fieldForceUserList,
  headQuaterList,
} from "../../redux/actions/fieldForceAction";
import FFTableData from "./FFtable-data";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import "./fieldForce.css";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import { useNavigate } from "react-router-dom";
import { vendorDivisionList } from "../../redux/actions/productActions";
import NumberPagination from "../../components/Pagination/number-pagination";

const FieldForceTable = ({
  search,
  setHeadquater,
  headquater,
  division,
  setDivisions,
  page_no,
  filterData,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const headquaterRef = useRef(null);
  const divisionRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [fildForceUserData, setFieldForceUserData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [openCity, setOpenCity] = useState(false);
  const [openDiv, setOpenDiv] = useState(false);
  const [headQuaterOptions, setHeadQuaterOptions] = useState([]);
  const [filteredHqOptions, setFilteredHqOptions] = useState(
    headQuaterOptions ?? []
  );
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [filteredDivOptions, setFilteredDivOptions] = useState(
    divisionOptions ?? []
  );

  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(headQuaterList(fetchHeadQuaterSuccess, fetchHeadQuaterError));
    dispatch(vendorDivisionList(onDevisionSuccess, onDevisionError));
  }, [dispatch]);

  const fetchHeadQuaterSuccess = (data) => {
    setHeadQuaterOptions(data);
    setFilteredHqOptions(data);
  };

  const fetchHeadQuaterError = (data) => {
    console.log(data);
  };

  const onDevisionSuccess = (data) => {
    setDivisionOptions(data);
  };

  const onDevisionError = (data) => {
    console.log(data);
  };

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  const selectedStatus =
    filterData?.status === "active"
      ? true
      : filterData?.status === "inactive"
      ? false
      : null;
  const selectedHeadquaters = filterData?.headquaters.split(",");
  const filteredHeadquatersValues = headQuaterOptions
    .filter((item) => selectedHeadquaters.includes(item.label))
    .map((item) => item.value);
  const HeadquatersJoin = filteredHeadquatersValues.join(",");
  const selectedDivisions = filterData?.divisions.split(",");
  const filteredDivisionsValues = divisionOptions
    .filter((item) => selectedDivisions.includes(item.label))
    .map((item) => item.value);
  const divisionsJoin = filteredDivisionsValues.join(",");

  useEffect(() => {
    setLoading(true);
    dispatch(
      fieldForceUserList(
        {
          headquaters: HeadquatersJoin,
          divisions: divisionsJoin,
          status: selectedStatus,
          page,
          search,
        },
        onSuccess,
        onError
      )
    );
  }, [page, selectedStatus, search, HeadquatersJoin, divisionsJoin, dispatch]);

  const fetchFieldForceUser = () => {
    dispatch(
      fieldForceUserList(
        {
          page,
          status: selectedStatus,
          search,
        },
        onSuccess,
        onError
      )
    );
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (filterData.status) queryParams.push(`status=${filterData.status}`);
  if (filterData?.headquaters.length > 0)
    queryParams.push(`headquaters=${filterData?.headquaters}`);
  if (filterData?.divisions.length > 0)
    queryParams.push(`divisions=${filterData?.divisions}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  const applyHQFilter = () => {
    navigate(
      `/field-force/user?page=1${search ? `&search=${search}` : ""}${
        headquater.length > 0 ? `&headquaters=${headquater}` : ""
      }${filterData.status ? `&status=${filterData.status}` : ""}${
        filterData?.divisions.length > 0
          ? `&divisions=${filterData?.divisions}`
          : ""
      }`
    );
  };

  const applyDivFilter = () => {
    navigate(
      `/field-force/user?page=1${search ? `&search=${search}` : ""}${
        filterData.status ? `&status=${filterData.status}` : ""
      }${
        filterData?.headquaters.length > 0
          ? `&headquaters=${filterData?.headquaters}`
          : ""
      }${division.length > 0 ? `&divisions=${division}` : ""}`
    );
  };

  const onSuccess = (data) => {
    setLoading(false);
    setFieldForceUserData(data.data.data);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setLoading(false);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const handleHqInputChange = (e) => {
    const inputValue = e.target.value;
    if (e.target.value) {
      const filtered = headQuaterOptions.filter((option) =>
        option.label.toLowerCase().includes(inputValue)
      );
      setFilteredHqOptions(filtered);
    } else {
      setFilteredHqOptions(headQuaterOptions);
    }
  };

  const handleDivInputChange = (e) => {
    const inputValue = e.target.value;
    const filtered = divisionOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue)
    );
    setFilteredDivOptions(filtered);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };
  const handleClickheadquaterOutside = (event) => {
    if (
      headquaterRef.current &&
      !headquaterRef.current.contains(event.target)
    ) {
      setOpenCity(false);
    }
  };
  const handleClickdivisionOutside = (event) => {
    if (divisionRef.current && !divisionRef.current.contains(event.target)) {
      setOpenDiv(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  useEffect(() => {
    if (openCity) {
      document.addEventListener("click", handleClickheadquaterOutside);
    } else {
      document.removeEventListener("click", handleClickheadquaterOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickheadquaterOutside);
    };
  }, [openCity]);

  useEffect(() => {
    if (openDiv) {
      document.addEventListener("click", handleClickdivisionOutside);
    } else {
      document.removeEventListener("click", handleClickdivisionOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickdivisionOutside);
    };
  }, [openDiv]);

  return (
    <>
      <div>
        <div className="table-container">
          <table className="main-table">
            <thead>
              <tr className="table-rows fs_12">
                <th className="table-heads text-nowrap " width={"4%"}>
                  #
                </th>
                <th className="table-heads text-nowrap" width={"8%"}>
                  User ID
                </th>
                <th className="table-heads text-nowrap" width={"8%"}>
                  Field Force Code
                </th>
                <th className="table-heads text-nowrap" width={"8%"}>
                  Company Employee ID
                </th>
                <th className="table-heads text-nowrap" width={"10%"}>
                  Employee Name
                </th>
                <th className="table-heads text-nowrap" width={"8%"}>
                  Designation
                </th>
                <th className="table-heads text-nowrap" width={"10%"}>
                  Designation Approval level
                </th>
                <th
                  ref={headquaterRef}
                  className="table-heads text-nowrap"
                  width={"12%"}
                >
                  <span
                    className={
                      openCity
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenCity(!openCity);
                    }}
                  >
                    <span
                      className={
                        filterData?.headquaters?.length > 0
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Head Quaters
                    </span>

                    {openCity ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>
                  {openCity ? (
                    <div className=" position-relative  ">
                      <div className="city-main-container ">
                        <div className="city-filter-form">
                          <div className="mx-3 my-2">
                            <input
                              type={"text"}
                              placeholder={"search"}
                              className="filter-input w-100 py-1 px-2"
                              onChange={handleHqInputChange}
                            />
                          </div>
                          <div
                            className="row"
                            style={{ height: "6.4rem", overflowY: "scroll" }}
                          >
                            {filteredHqOptions.map((item, index) => (
                              <div
                                className="col-5 d-flex align-items-center ms-4"
                                key={index}
                              >
                                <div>
                                  <span className="fs_14 my-1">
                                    <input
                                      type="checkbox"
                                      name="headquaters"
                                      id={item.label}
                                      checked={headquater.find(
                                        (ex) => ex === item?.label
                                      )}
                                      className="ffCheck"
                                      onClick={() => {
                                        if (headquater.includes(item.label)) {
                                          setHeadquater((prev) =>
                                            prev.filter(
                                              (ex) => ex !== item.label
                                            )
                                          );
                                        } else {
                                          setHeadquater((prev) => [
                                            ...prev,
                                            item.label,
                                          ]);
                                        }
                                      }}
                                    />
                                  </span>
                                </div>
                                <div className="mt-2 mx-2">
                                  <label
                                    htmlFor={item.label}
                                    className="color_747f9e fs_14 cursor_pointer"
                                  >
                                    {item.label}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mx-3 gap-3">
                          <button
                            type="button"
                            className="filter-clear-btn px-3 py-1 fs_14"
                            onClick={() => {
                              setHeadquater([]);
                              setOpenCity(!openCity);
                              setFilteredHqOptions(headQuaterOptions);
                              navigate(
                                `/field-force/user?page=1${
                                  search ? `&search=${search}` : ""
                                }${
                                  filterData?.divisions.length > 0
                                    ? `&divisions=${filterData?.divisions}`
                                    : ""
                                }`
                              );
                            }}
                          >
                            clear
                          </button>
                          <button
                            className="filter-btn px-2 py-1 fs_14"
                            onClick={() => {
                              setOpenCity(!openCity);
                              applyHQFilter();
                            }}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  ) : null}
                </th>
                <th
                  ref={divisionRef}
                  className="table-heads text-nowrap"
                  width={"12%"}
                >
                  <span
                    className={
                      openDiv
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenDiv(!openDiv);
                    }}
                  >
                    <span
                      className={
                        filterData?.divisions?.length > 0
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Divisions
                    </span>

                    {openDiv ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>
                  {openDiv ? (
                    <div className=" position-relative">
                      <div className="city-main-container">
                        <div className="city-filter-form">
                          <div className="mx-2 my-1">
                            <input
                              type={"text"}
                              placeholder={"search"}
                              className="filter-input w-100 py-1 px-2"
                              onChange={handleDivInputChange}
                            />
                          </div>
                          <div
                            className="row"
                            style={{ height: "6.4rem", overflowY: "scroll" }}
                          >
                            {(filteredDivOptions.length > 0
                              ? filteredDivOptions
                              : divisionOptions
                            ).map((item, index) => (
                              <div
                                className="col-5 d-flex align-items-center ms-4"
                                key={index}
                              >
                                <div>
                                  <span className="fs_14 my-1">
                                    <input
                                      type="checkbox"
                                      name="divisions"
                                      id={item.label}
                                      checked={division.find(
                                        (ex) => ex === item.label
                                      )}
                                      className="ffCheck"
                                      onClick={() => {
                                        if (division.includes(item.label)) {
                                          setDivisions((prev) =>
                                            prev.filter(
                                              (ex) => ex !== item.label
                                            )
                                          );
                                        } else {
                                          setDivisions((prev) => [
                                            ...prev,
                                            item.label,
                                          ]);
                                        }
                                      }}
                                    />
                                  </span>
                                </div>
                                <div className="mt-2 mx-2">
                                  <label
                                    htmlFor={item.label}
                                    className="color_747f9e fs_14 cursor_pointer"
                                  >
                                    {item.label}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mx-3 gap-3">
                          <button
                            type="button"
                            className="filter-clear-btn px-3 py-1 fs_14"
                            onClick={() => {
                              setDivisions([]);
                              setOpenDiv(!openDiv);
                              setFilteredDivOptions([]);
                              navigate(
                                `/field-force/user?page=1${
                                  search ? `&search=${search}` : ""
                                }${
                                  filterData.headquaters.length > 0
                                    ? `&headquaters=${filterData.headquaters}`
                                    : ""
                                }`
                              );
                            }}
                          >
                            clear
                          </button>
                          <button
                            className="filter-btn px-2 py-1 fs_14"
                            onClick={() => {
                              setOpenDiv(!openDiv);
                              applyDivFilter();
                            }}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  ) : null}
                </th>

                <th
                  ref={componentRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    <span
                      className={
                        filterData.status ? "Medium_Purple fw_700" : ""
                      }
                    >
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className="position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="status"
                            value={"active"}
                            checked={filterData.status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/field-force/user?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active${
                                  filterData?.headquaters.length > 0
                                    ? `&headquaters=${filterData?.headquaters}`
                                    : ""
                                }${
                                  division.length > 0
                                    ? `&divisions=${division}`
                                    : ""
                                }`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              filterData.status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="status"
                            value={"inactive"}
                            checked={filterData.status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/field-force/user?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive${
                                  filterData?.headquaters.length > 0
                                    ? `&headquaters=${filterData?.headquaters}`
                                    : ""
                                }${
                                  division.length > 0
                                    ? `&divisions=${division}`
                                    : ""
                                }`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              filterData.status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/field-force/user?page=1${
                                search ? `&search=${search}` : ""
                              }${
                                filterData?.headquaters.length > 0
                                  ? `&headquaters=${filterData?.headquaters}`
                                  : ""
                              }${
                                division.length > 0
                                  ? `&divisions=${division}`
                                  : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>

                <th className="table-heads-action" width={"24%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }} className="">
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : fildForceUserData?.fieldForceUsers?.length > 0 ? (
                <>
                  {fildForceUserData?.fieldForceUsers?.map((eachRow, index) => (
                    <FFTableData
                      key={index}
                      data={eachRow}
                      index={index}
                      fetchFieldForceUser={fetchFieldForceUser}
                      currentPage={fildForceUserData?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {fildForceUserData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={fildForceUserData?.pagination?.currentPage}
              totalPages={fildForceUserData?.pagination?.totalPages}
              path={"/field-force/user"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default FieldForceTable;

export const customStyles2 = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#000",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
